import React, { FC } from 'react';
import { Flex, Text, useTheme } from '@chakra-ui/react';
import { TooltipProps } from 'recharts';
import { rem } from 'utils/fonts';
import { formatNumber } from 'utils/numberFormatter';

interface CustomTooltipProps {
  rounded?: boolean;
}

// @ts-ignore
const Tooltip: FC<TooltipProps & CustomTooltipProps> = ({ active, payload, rounded = true }) => {
  const { colors } = useTheme();

  if (active && payload && payload.length) {
    const { payload: data } = payload[0];
    const dataValue = formatNumber(data.value);

    return (
      <Flex
        borderRadius={rounded ? '50%' : '9px'}
        w={rounded ? '82px' : '90px'}
        h={rounded ? '82px' : 'auto'}
        p={rounded ? 0 : '3px'}
        border={`2px solid ${data.color}`}
        direction="column"
        align="center"
        justify="center"
        bg={colors.white}
      >
        <Text fontSize={rem(16)} fontWeight="bold" color="gray.900" textAlign="center">
          {dataValue}
        </Text>
        {(data.percent || data.kilosCO2e) && (
          <Text fontSize={rem(14)} fontWeight="normal" color="gray.400" textAlign="center" mt="-5px">
            {data.percent ? (
              <>{data.percent.toFixed(2)}%</>
            ) : (
              <>
                {data.kilosCO2e} CO<sub>2</sub>e
              </>
            )}
          </Text>
        )}
      </Flex>
    );
  }

  return null;
};

export default Tooltip;
